import React, { useState, useEffect, useRef } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import listPlugin from "@fullcalendar/list";
import interactionPlugin from "@fullcalendar/interaction";
import moment from "moment";
import "./calendar.css";

import { getToken, base_url } from "../../config/config";

const MyCalendar = () => {
  const [events, setEvents] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [selectedEmployee, setSelectedEmployee] = useState("");
  const modalRef = useRef(null);

  const [employees, setEmployees] = useState([]);
  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        const token = getToken();
        const response = await fetch(`${base_url}/v1/getAllEmployees`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          throw new Error("Failed to fetch employees");
        }

        const data = await response.json();
        // Transform the employee data to match the required format
        const formattedEmployees = data.map((emp) => ({
          title: emp.name,
          color: emp.color || getRandomColor(), // Fallback to random color if not set
        }));

        setEmployees(formattedEmployees);
      } catch (error) {
        console.error("Error fetching employees:", error);
      }
    };

    fetchEmployees();
  }, []);
  useEffect(() => {
    const fetchAnrs = async () => {
      try {
        const response = await fetch(`${base_url}/v1/getAllAnrCalendar`);
        if (!response.ok) {
          throw new Error("Failed to fetch ANR data");
        }
        const data = await response.json();
        console.log("Fetched Data:", data); // Debug: Check fetched data
        setEvents(createEvents(data));
      } catch (error) {
        console.error("Error fetching ANR data:", error);
      }
    };

    fetchAnrs();
  }, []);

  const handleEventClick = (info) => {
    setSelectedEvent(info.event);
    console.log("info", info.event);
    setSelectedEmployee(info.event.extendedProps.miterbiter);
    if (modalRef.current) {
      modalRef.current.showModal();
    }
  };

  const closeModal = () => {
    setSelectedEvent(null);
    if (modalRef.current) {
      modalRef.current.close();
    }
  };

  const handleEmployeeChange = (e) => {
    setSelectedEmployee(e.target.value);
  };

  const updateEventEmployee = async () => {
    if (selectedEvent) {
      // Make API call to update miterbiter
      console.log(selectedEvent.extendedProps);
      try {
        const response = await fetch(
          `${base_url}/v1/updateMiterbiterCalendar`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              id: selectedEvent.extendedProps.id,
              processId: selectedEvent.extendedProps.processId,
              miterbiter: selectedEmployee,
            }),
          }
        );

        if (!response.ok) {
          throw new Error("Failed to update miterbiter");
        }

        // Update the event locally
        const updatedEvents = events.map((event) => {
          if (event.id === selectedEvent.id) {
            return {
              ...event,
              title: `${event.resource}: ${event.process} - (${selectedEmployee})`,
              backgroundColor: getEmployeeColor(selectedEmployee),
              extendedProps: {
                ...event.extendedProps,
                miterbiter: selectedEmployee,
              },
            };
          }
          return event;
        });
        setEvents(updatedEvents);
        closeModal();
      } catch (error) {
        console.error("Error updating miterbiter:", error);
      }
    }
  };

  const holidays = [
    { holiday: "Neujahr in Deutschland", month: 1, day: 1 },
    {
      holiday: "Karfreitag in Deutschland (Ostern in Deutschland)",
      month: 3,
      day: 29,
    },
    {
      holiday: "Ostermontag in Deutschland (Ostern in Deutschland)",
      month: 4,
      day: 1,
    },
    { holiday: "Tag der Arbeit in Deutschland", month: 5, day: 1 },
    { holiday: "Christi Himmelfahrt in Deutschland", month: 5, day: 9 },
    {
      holiday: "Pfingstmontag in Deutschland (Pfingsten in Deutschland)",
      month: 5,
      day: 20,
    },
    { holiday: "Tag der Deutschen Einheit", month: 10, day: 3 },
    { holiday: "Reformationstag in Deutschland", month: 10, day: 31 },
    {
      holiday: "1. Weihnachtstag in Deutschland (Weihnachten in Deutschland)",
      month: 12,
      day: 25,
    },
    {
      holiday: "2. Weihnachtstag in Deutschland (Weihnachten in Deutschland)",
      month: 12,
      day: 26,
    },
  ];

  useEffect(() => {
    // Render holidays with a different color
    holidays.forEach((holiday) => {
      const holidayDate = moment().set({
        month: holiday.month - 1,
        date: holiday.day,
      });
      const dayEl = document.querySelector(
        `.fc-day[data-date="${holidayDate.format("YYYY-MM-DD")}"]`
      );
      if (dayEl) {
        dayEl.classList.add("holiday-cell");
        dayEl.setAttribute("title", holiday.holiday);
      }
    });
  }, []);

  const ColorData = [
    { title: "CNC Fräsen", color: "#1FD655" },
    { title: "Konventionell Fräsen", color: "#649200" },
    { title: "Sägen", color: "#844204" },
    { title: "Stoßen", color: "#557882" },
  ];
  const getRandomColor = () => {
    const colors = [
      "blue",
      "#649200",
      "#844204",
      "#557882",
      "green",
      "purple",
      "orange",
      "cyan",
    ];
    return colors[Math.floor(Math.random() * colors.length)];
  };
  // const EmployeeData = [
  //   { title: "Daniel Herzog", color: "blue" },
  //   { title: "Michael Otte", color: "#649200" },
  //   { title: "Ronald Hasche", color: "#844204" },
  //   { title: "Rico Rasche", color: "#557882" },
  //   { title: "Jens Schubert", color: "green" },
  //   { title: "Jörg Melms", color: "purple" },
  //   { title: "Maik Heinig", color: "purple" },
  //   { title: "Marino Uhlemann", color: "orange" },
  //   { title: "Jörg Taschner", color: "cyan" },
  // ];

  const createEvents = (Anrs) => {
    const events = [];
    Anrs.forEach((anr) => {
      anr.process.forEach((process) => {
        const currentDate = moment(anr.date, "DD-MM-YYYY");
        const title = `${anr.number}: ${process.title} - (${process.miterbiter})`;
        let color = "grey"; // Default color

        // Check if miterbiter exists in EmployeeData, then get color
        const employee = employees.find(
          (emp) => emp.title === process.miterbiter
        );
        if (employee) {
          color = employee.color;
        } else {
          const colorObj = ColorData.find(
            (data) => data.title === process.title
          );
          color = colorObj ? colorObj.color : "grey";
        }

        let i = 0;
        let currentDay = currentDate.clone();
        while (i < process.days) {
          // Skip weekends and holidays
          if (
            currentDay.day() !== 0 &&
            currentDay.day() !== 6 &&
            !isHoliday(currentDay, holidays)
          ) {
            events.push({
              id: `${anr.number}-${process.title}-${i}`, // Adding index to id for better identification
              title: title,
              start: currentDay.format(),
              end: currentDay.clone().add(1, "days").format(),
              resource: anr.number,
              process: process.title,
              backgroundColor: color,
              extendedProps: {
                id: anr._id,
                processId: process._id,
                miterbiter: process.miterbiter,
                description: anr.description || "",
              },
            });
            i++;
          }
          currentDay = currentDay.add(1, "days");
        }
      });
    });

    return events;
  };

  const isHoliday = (date, holidays) => {
    return holidays.some((holiday) => {
      return date.month() === holiday.month - 1 && date.date() === holiday.day;
    });
  };

  const getEmployeeColor = (employeeName) => {
    const employee = employees.find((emp) => emp.title === employeeName);
    return employee ? employee.color : "grey";
  };

  const eventContent = ({ event }) => {
    return (
      <>
        <div>{event.title}</div>
      </>
    );
  };

  return (
    <div>
      <FullCalendar
        plugins={[dayGridPlugin, timeGridPlugin, listPlugin, interactionPlugin]}
        events={events}
        editable={true}
        selectable={true}
        eventDisplay="block"
        eventClick={handleEventClick}
        eventContent={eventContent}
      />
      {selectedEvent && (
        <dialog ref={modalRef}>
          <div>
            <h3>{selectedEvent.title}</h3>
            <p>Start: {moment(selectedEvent.start).format("YYYY-MM-DD")}</p>
            <p>End: {moment(selectedEvent.end).format("YYYY-MM-DD")}</p>
            <p>
              Description: <b>{selectedEvent.extendedProps.description}</b>
            </p>
            <label>
              Change Miterbiter:
              <select value={selectedEmployee} onChange={handleEmployeeChange}>
                {employees.map((employee) => (
                  <option key={employee.title} value={employee.title}>
                    {employee.title}
                  </option>
                ))}
              </select>
            </label>
            <button onClick={updateEventEmployee}>Update</button>
            <button onClick={closeModal}>Close</button>
          </div>
        </dialog>
      )}
    </div>
  );
};

export default MyCalendar;
